import React, { useEffect, useRef, useState } from 'react';
import styles from './WineFlipCard.module.css';
import MenuCard from '../Card/Card';
import { formatPrice } from '../../utils/formatPrice';

const BADGE_DEFS = [
  { key: 'isProductOfDay', altKey: 'productOfDay', emoji: '🌟', label: 'Día' },
  { key: 'isSignature', altKey: 'signature', emoji: '✨', label: 'Signature' },
  { key: 'isRecommended', altKey: 'recommended', emoji: '⭐', label: 'Recomendado' },
  { key: 'isMostOrdered', altKey: 'mostOrdered', emoji: '🔥', label: 'Más pedido' },
  { key: 'isShareable', altKey: 'shareable', emoji: '👥', label: 'Compartir' },
];

const getItemBadges = (item) =>
  BADGE_DEFS.filter((def) => item[def.key] || item[def.altKey]);

const WineFlipCard = ({ item, categoryId, categoryName = '', initialOpen = false }) => {
  const [showCard, setShowCard] = useState(Boolean(initialOpen));
  const cardRef = useRef(null);
  const price = formatPrice(item.price);
  
  // Formatear descripción
  let formattedDescription = item.description
    ? item.description.replace(/\n/g, '<br/>')
    : '';

  // Extraer información adicional (notas, color, sabor)
  // Buscar en diferentes campos posibles de la API
  const notes = item.notes || item.tastingNotes || item.notas || item.tasting_notes || '';
  const color = item.color || item.colour || '';
  const flavor = item.flavor || item.sabor || item.taste || '';
  
  // Extraer tipo de vino de la descripción o nombre para el tag
  const wineType = item.wineType || item.type || item.category || '';

  // Extraer información de uvas y bodega - intentar múltiples campos
  const grapes = item.grapes || item.varietal || item.variety || item.uvas || '';
  const winery = item.winery || item.bodega || item.producer || item.bodegas || '';

  const handleClick = () => {
    setShowCard(true);
  };

  const handleBack = () => {
    setShowCard(false);
  };

  useEffect(() => {
    if (initialOpen && cardRef.current) {
      cardRef.current.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  }, [initialOpen]);

  // Dividir el nombre en líneas si tiene espacios o caracteres especiales
  const nameLines = item.name ? item.name.split(/\s+/).filter(Boolean) : [];
  const firstLine = nameLines[0] || item.name || 'Vino';
  const secondLine = nameLines.slice(1).join(' ') || '';

  // Asegurar que siempre haya contenido para mostrar
  if (!item || !item.name) {
    return null;
  }

  const badges = getItemBadges(item);

  // Si showCard es true, mostrar el componente Card
  if (showCard) {
    return (
      <div
        ref={cardRef}
        id={`wine-${item.id}`}
        style={{ position: 'relative', width: '100%', maxWidth: '320px', margin: '0 auto', cursor: 'pointer' }}
        onClick={handleBack}
      >
        <MenuCard 
          item={item} 
          categoryId={categoryId}
          categoryName={categoryName}
          brutalistStyle={true}
        />
      </div>
    );
  }

  return (
    <article className={styles.zineCard} ref={cardRef} id={`wine-${item.id}`}>
      <div 
        className={styles.flipCard}
        onClick={handleClick}
      >
        {/* Front of card - Estilo brutalista */}
        <div className={styles.flipCardFront}>
          <div className={styles.imageContainer}>
            <img
              src={item.image?.small || require('../../Assets/Placeholder.png')}
              alt={item.name}
              className={item.image?.small ? styles.wineImage : styles.placeholderImage}
              loading="lazy"
            />
            {/* Tag de tipo de vino */}
            {wineType && (
              <div className={styles.wineTag}>
                {wineType.toUpperCase()}
              </div>
            )}
            {/* Badges (recomendado, signature, etc.) */}
            {badges.length > 0 && (
              <div className={styles.wineBadges}>
                {badges.map((badge) => (
                  <span key={badge.key} className={styles.wineBadge}>
                    {badge.emoji} {badge.label}
                  </span>
                ))}
              </div>
            )}
            {/* Título superpuesto en la imagen */}
            <div className={styles.titleOverlay}>
              <h3 className={styles.wineTitle}>
                {firstLine}
                {secondLine && <><br/>{secondLine}</>}
              </h3>
            </div>
          </div>
          <div className={styles.frontContent}>
            <div className={styles.priceContainer}>
              <div className={styles.rotatedPrice}>
                {price}
              </div>
            </div>
            <div className={styles.tapToDiscover}>
              <span className={styles.tapText}>TAP TO DISCOVER</span>
              <span className={styles.arrowIcon}>→</span>
            </div>
            <div className={styles.divider}></div>
            <div className={styles.wineInfo}>
              {grapes && <span>{grapes}</span>}
              {grapes && winery && <span>•</span>}
              {winery && <span>{winery}</span>}
              {!grapes && !winery && item.name && <span>{item.name}</span>}
            </div>
          </div>
        </div>

      </div>
    </article>
  );
};

export default WineFlipCard;
